import React from 'react'
import '../assets/footer.css'

function Footer() {
  return (
    <div className='container' id='pied'>
        <img src={window.location.origin +"/images/logo_footer.svg"} alt="" />
        <span className='subscribbe'>Abonnez-vous à notre newsletter</span>
        <div className="search-footer">
              <input type="email" placeholder='Votre adresse e-mail' />
              <button><img src={window.location.origin +"/images/fleche_noire.svg"} alt="" /></button>
        </div>
        <div className="container bas">
          <div className="item-bas social">
            <span className='network'>SUIVEZ-NOUS POUR TOUTES LES EXCLUSIVITÉS</span>
            <img src={window.location.origin +"/images/insta_dark.svg"} alt="" />
            <span>@2022, Shoptacbd, Développé avec ❤️ par Linnovlab</span>
          </div>
          <div className="item-bas">
            <span className="title-bas">Service Client</span>
            <div className="content-bas">
                <span>Du Lundi au Dimanche <br /> de 11:00 à 18:00</span>
                <span><span className="left">Tél : </span><span className="right">01 83 91 29 91</span></span>
                <span><span className="left">Email : </span><span className="right">contact@shoptacbd.com</span></span>
            </div>
          </div>
          <div className="item-bas">
          <span className="title-bas">Où nous trouver ?</span>
            <div className="content-bas">
                <span><span className="left">Adresse 1 : </span>19 Av. de Choisy, <br />75013 Paris (7j/7)</span>
                <span className='mt-2'><span className="left">Adresse 2 : </span>91 Rue du Faubourg <br />Saint-Martin, 75010 Paris <br />(Fermé dimanche)</span>
            </div>
          </div>
          <div className="item-bas">
          <span className="title-bas">Informations</span>
            <div className="content-bas">
                <span>À notre propos</span>
                <span>Politique de confidentialité</span>
                <span>Mentions légales</span>
                <span>Politique de remboursement</span>
                <span>Politique d’expédition</span>
                <span>Conditions d’utilisation</span>
            </div>
          </div>
        </div>
        <div className='bas-mobile container mt-5'>
          <div className="item-bas social">
            <p className='network text-center'>SUIVEZ-NOUS POUR TOUTES LES EXCLUSIVITÉS</p>
            <img src={window.location.origin +"/images/insta_dark.svg"} alt="" />
          </div>
          <div className="accordion footer-accordion mt-4" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-foot-header" id="headingOne">
                <button className="accordion-button acc-foot-btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                 Service client
                </button>
              </h2>
              <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-foot-header" id="headingTwo">
                <button className="accordion-button collapsed acc-foot-btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Où nous trouver ?
                </button>
              </h2>
              <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                 until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-foot-header" id="headingThree">
                <button className="accordion-button collapsed acc-foot-btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  Informations
                </button>
              </h2>
              <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default Footer